export default "__VITE_ASSET__DMV2PIt6__"